<template>
  <div :class="inlineClasses">
    <div v-if="label" class="form-label" :class="labelClasses">{{ label }}</div>
    <input
        class="mt-1 form-input w-full"
        :class="extraClasses"
        :id="id"
        :placeholder="placeholder"
        ref="input"
        :type="type"
        :disabled="disabled"
        :readonly="readOnly"
        v-model="myValue"
        @keyup="$emit('keyup',$event)"
        @focusout="$emit('focusout',$event)"
    />
    <slot name="extra"></slot>
    <field-error-help-length :error="error" :help="help" :input-length="myValue.length"
                             :max-length="maxLength"></field-error-help-length>
  </div>
</template>
<script>
export default {
  name: "my-input",
  props: {
    error: {type: String},
    help: {type: String},
    id: {type: String},
    label: {type: String},
    placeholder: {type: String},
    maxLength: {type: Number, default: 0},
    type: {type: String, default: "input"},
    value: {type: String},
    inline: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    readOnly: {type: Boolean, default: false},
  },
  data() {
    return {
      myValue: this.value ? this.value : '',
    }
  },
  computed: {
    labelClasses() {
      return this.inline ? 'w-1/3' : '';
    },
    inlineClasses() {
      return this.inline ? 'flex mb-4 justify-center items-center' : '';
    },
    extraClasses() {
      let classes = this.error ? 'form-error' : '';
      classes += this.inline ? ' ml-2' : '';
      classes += this.readOnly || this.disabled ? ' bg-gray-300 text-gray-500' : '';
      return classes;
    }
  },
  watch: {
    value() {
      this.myValue = this.value;
    },
    myValue() {
      this.$emit('input', this.myValue);
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    }
  }
}
</script>